<template>
  <BaseButton primary @click="openNewEmailTemplateDialog"> New Email Template </BaseButton>
</template>

<script>
import { accountEmailTemplatesClient } from '@/api/clients';

export default {
  props: {
    accountId: {
      type: String,
      default: null,
    },
  },
  methods: {
    submit(data) {
      return accountEmailTemplatesClient.store(this.accountId, data);
    },
    openNewEmailTemplateDialog() {
      this.$modal.show({
        component: () =>
          import(
            '@/components/EmailTemplate/CreateEmailTemplateDialog/CreateEmailTemplateDialog.vue'
          ),
        props: {
          accountId: this.accountId,
        },
        on: {
          created: (emailTemplate) => {
            this.$router.push({
              name: 'accounts.accountId.emailTemplates.emailTemplateId.edit',
              params: {
                accountId: emailTemplate.account_id,
                emailTemplateId: emailTemplate.id,
              },
            });
          },
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
